import { Select } from "antd";

export const VisualizeSelector = ({ selectedType, setSelectedType }) => {
    return (
        <Select
            style={{ width: 150 }}
            placeholder="Select Type"
            value={selectedType}
            onChange={setSelectedType}
            options={[
                { label: "% of each subset", value: true },
                { label: "# of matches in each subset", value: false },
            ]}
            size="small"
        />
    );
};
